import { render, staticRenderFns } from "./GardensGrid.vue?vue&type=template&id=0293dbe0"
import script from "./GardensGrid.vue?vue&type=script&lang=ts"
export * from "./GardensGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports